import { render, staticRenderFns } from "./Dice.vue?vue&type=template&id=4542cfae&scoped=true&"
import script from "./Dice.vue?vue&type=script&lang=js&"
export * from "./Dice.vue?vue&type=script&lang=js&"
import style0 from "./Dice.vue?vue&type=style&index=0&id=4542cfae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4542cfae",
  null
  
)

export default component.exports